import { useEffect, useRef, useState } from 'react'

export function useThreadListRowKebabMenuModel({ isEditingTitle = false, menuItems = [] }) {
  const kebabRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const prevMenuOpen = useRef(false)

  const closeMenu = () => {
    setMenuOpen(false)
    setMenuAnchorEl(null)
  }

  useEffect(() => {
    if (prevMenuOpen.current && !menuOpen && !isEditingTitle) {
      kebabRef.current?.focus()
    }
    prevMenuOpen.current = menuOpen
  }, [menuOpen, isEditingTitle])

  return {
    kebabRef,
    menuOpen,
    setMenuOpen,
    menuAnchorEl,
    setMenuAnchorEl,
    closeMenu,
    menuItems,
    isEditingTitle,
  }
}
